export function formatFileSize(bytes: number, decimals: number = 2): string {
  const num = typeof bytes === 'number' ? bytes : Number(bytes);
  if (isNaN(num) || num < 0) return '';
  // Handle zero bytes
  if (num === 0) return '0 B';
  const k = 1024;
  const sizes = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
  const unitIndex = Math.floor(Math.log(bytes) / Math.log(k));
  // Ensure we don't exceed array bounds
  const safeUnitIndex = Math.min(unitIndex, sizes.length - 1);
  const size = parseFloat(
    (bytes / Math.pow(k, safeUnitIndex)).toFixed(decimals)
  );
  return `${size} ${sizes[safeUnitIndex]}`;
}
